import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class TrainingPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.trainingRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.trainingImport,
    );
    this.trainingAutocomplete = permissionChecker.match(
      Permissions.values.trainingAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.trainingCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.trainingEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.trainingDestroy,
    );
  }
}
